export default {
  baseUrl: '',
  apiPath: '/api/v1',
  stripeKey: 'pk_live_7T8GOk3WZSBX6xR1y1tfkcUU',
}
